import React from "react";
import { PageHero } from "@/components/shared/PageHero";
import { COMPANY } from "@/data/site";

const sections = [
  { h: "Information We Collect", p: "We collect information you provide directly — such as your name, phone number, email and relocation details — when you request a quote, contact us, apply for a job or book a shipment." },
  { h: "How We Use Your Information", p: "Your information is used solely to provide and improve our services: preparing quotes, coordinating moves, sending shipment status updates and responding to enquiries. We never sell your data." },
  { h: "SMS & Communication", p: "By providing your mobile number, you consent to receive shipment status updates and service-related messages. Message and data rates may apply. You can opt out at any time by contacting us." },
  { h: "Data Security", p: "We apply reasonable technical and organisational measures to protect your personal information against unauthorised access, loss or misuse." },
  { h: "Cookies", p: "Our website may use minimal cookies to improve your browsing experience. You can control cookies through your browser settings." },
  { h: "Your Rights", p: "You may request access to, correction of, or deletion of your personal information at any time by emailing us." },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHero breadcrumb="Privacy Policy" eyebrow="Legal" title="Privacy Policy" description="Your privacy matters to us. Here's how we handle your information." />
      <section className="bg-white py-24 lg:py-32">
        <div className="container-x max-w-3xl space-y-10">
          {sections.map((s) => (
            <div key={s.h}>
              <h2 className="font-heading font-bold text-2xl text-ink">{s.h}</h2>
              <p className="mt-3 text-muted-foreground leading-relaxed">{s.p}</p>
            </div>
          ))}
          <div className="rounded-3xl bg-surface border border-gray-100 p-8">
            <h2 className="font-heading font-bold text-2xl text-ink">Contact Us</h2>
            <p className="mt-3 text-muted-foreground">For any privacy-related questions, reach us at <a href={`mailto:${COMPANY.email}`} className="text-brand font-semibold">{COMPANY.email}</a> or call {COMPANY.phone}.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
